<template>
  <div>
    <v-container class="pa-3">
      <v-flex xs4 class="mt-2">
        <v-layout row wrap>
          <v-flex xs6>
            <div class="form-control" style="position: relative">
              <div class="labelinputontop">Start date</div>
              <DatePickerWithoutButton @change="onChangeDate" v-model="selectedDate.start">
                <input readonly :value="dateFormat(selectedDate.start)" type="text" />
              </DatePickerWithoutButton>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <div class="form-control" style="position: relative">
              <div class="labelinputontop">End date</div>
              <DatePickerWithoutButton @change="onChangeDate" v-model="selectedDate.end">
                <input readonly :value="dateFormat(selectedDate.end)" type="text" />
              </DatePickerWithoutButton>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <div>
        <v-layout row wrap>
          <v-flex xs2>
            <div class="pa-2" style="background-color: #eee; border-radius: 8px">
              <div>
                <div v-if="['studio7', 'ticket2'].includes(selectedBot.theme)">Page</div>
                <div v-if="['studio7', 'ticket2'].includes(selectedBot.theme)">
                  <v-radio-group class="mt-0" row v-model="filter.pageid" @change="onSearch">
                    <v-radio label="All" value="" color="primary"></v-radio>
                    <v-radio
                      :key="page.pageid"
                      v-for="page in $store.state.com7pages"
                      :label="page.name"
                      :value="page.pageid"
                      color="primary"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div>Channel</div>
                <div>
                  <v-radio-group class="mt-0" row v-model="filter.channel" @change="onSearch">
                    <v-radio label="All" value="" color="primary"></v-radio>
                    <v-radio label="Facebook" value="facebook" color="primary"></v-radio>
                    <v-radio label="Line" value="line" color="primary"></v-radio>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs10>
            <div v-if="loading">
              <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
            </div>
            <div v-else>
              <div class="px-2">
                <div style="display: flex">
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">Answered</div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.answered ? databystatus.answered : 0 }}
                      </div>
                    </v-card>
                  </div>
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">Pending</div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.pending ? databystatus.pending : 0 }}
                      </div>
                    </v-card>
                  </div>
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">Close</div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.closed ? databystatus.closed : 0 }}
                      </div>
                    </v-card>
                  </div>
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">
                        Cancelled
                      </div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.cancelled ? databystatus.cancelled : 0 }}
                      </div>
                    </v-card>
                  </div>
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">
                        Cold case
                      </div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.cold_case ? databystatus.cold_case : 0 }}
                      </div>
                    </v-card>
                  </div>
                </div>
              </div>
              <div>
                <v-layout row wrap>
                  <v-flex xs8>
                    <div class="mt-2">
                      <OverviewTicketChart
                        :key="apexchartKey"
                        :data="databystatus.timestampList"
                      ></OverviewTicketChart>
                    </div>
                  </v-flex>
                  <v-flex xs4 class="pa-3">
                    <v-layout row wrap>
                      <v-flex xs6 style="border-left: 4px solid rgb(216 216 216)">
                        <div class="pa-2" style="height: 100px">
                          <div class="primary--text" style="font-size: 17px">Received</div>
                          <div style="font-weight: bold">{{ totalticket }}</div>
                        </div>
                      </v-flex>
                      <v-flex xs6 style="border-left: 4px solid rgb(216 216 216)">
                        <div class="pa-2" style="height: 100px">
                          <div class="primary--text" style="font-size: 17px">Resolved</div>
                          <div style="font-weight: bold">
                            {{ databystatus.closed ? databystatus.closed : 0 }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex class="mt-3" xs6 style="border-left: 4px solid rgb(216 216 216)">
                        <div class="pa-2" style="height: 100px">
                          <div class="primary--text" style="font-size: 17px">
                            Average first response time
                          </div>
                          <div style="font-weight: bold">
                            {{
                              formatAvg(
                                databystatus.first_response_time
                                  ? databystatus.first_response_time
                                  : 0 / databystatus.first_response_time_count
                                  ? databystatus.first_response_time_count
                                  : 0
                              )
                            }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex class="mt-3" xs6 style="border-left: 4px solid rgb(216 216 216)">
                        <div class="pa-2" style="height: 100px">
                          <div class="primary--text" style="font-size: 17px">
                            Average resolved ticket time
                          </div>

                          <div style="font-weight: bold">
                            {{
                              formatAvg(
                                databystatus.resolved_ticket_time
                                  ? databystatus.resolved_ticket_time
                                  : 0 / databystatus.resolved_ticket_time_count
                                  ? databystatus.resolved_ticket_time_count
                                  : 0
                              )
                            }}
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-layout row wrap>
                  <v-flex xs5>
                    <OverviewAdminChart
                      :key="apexchartKeyClosecase"
                      :data="databyclosecase"
                    ></OverviewAdminChart>
                  </v-flex>
                  <v-flex xs7 class="pl-2">
                    <v-card class="pa-2" color="#eee">
                      <div>
                        <table style="border: none" cellspacing="0" cellpadding="0">
                          <tr>
                            <td
                              class="text-xs-center primary--text"
                              style="font-weight: bold; text-decoration: underline"
                            >
                              หัวข้อ
                            </td>
                            <td
                              class="text-xs-center primary--text"
                              style="font-weight: bold; text-decoration: underline"
                            >
                              Received
                            </td>
                            <td
                              class="text-xs-center primary--text"
                              style="font-weight: bold; text-decoration: underline"
                            >
                              Resolved
                            </td>
                          </tr>
                          <tr :key="k" v-for="(item, k) in databyclosecasebyadmin">
                            <td>
                              {{ k }}
                            </td>
                            <td class="text-xs-center">
                              {{ item.recieved }}
                            </td>
                            <td class="text-xs-center">
                              {{ item.resolved }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import OverviewTicketChart from './OverviewTicketChart.vue'
import OverviewAdminChart from './OverviewAdminChart.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  components: { DatePickerWithoutButton, OverviewTicketChart, OverviewAdminChart, ScaleLoader },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      databystatus: {},
      databyclosecase: {},
      databyclosecasebyadmin: {},
      apexchartKey: 0,
      apexchartKeyClosecase: 0,
      filter: {
        pageid: '',
        channel: ''
      },
      loading: false,
      totalticket: 0,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    formatAvg(secs) {
      const formatted = moment.utc(parseInt(secs) * 1000).format('H[h] m[m] s[s]')
      return formatted
    },
    async getAllData() {
      return new Promise(async (resolve) => {
        var allGet = [
          this.getTicketsByStatus(),
          this.getTicketsCloseCase(),
          this.getTicketsCloseCaseDetailByAdmin()
        ]
        this.loading = true
        await Promise.all(allGet)
        this.loading = false
        resolve()
      })
    },
    onSearch() {
      this.getAllData()
    },
    onChangeDate() {
      this.getAllData()
    },
    getTicketsCloseCase() {
      return new Promise((resolve) => {
        var data = {
          startDate: this.selectedDate.start, // YYYY-MM-DD
          endDate: this.selectedDate.end, // YYYY-MM-DD
          pageid: this.selectedBot.pageid
        }

        if (this.filter.channel) {
          Object.assign(data, { channel: this.filter.channel })
        }
        api.TDGetTicketsCloseCase(data, (err, response) => {
          if (response.data && response.data.length) {
            this.databyclosecase = response.data[0]
          } else this.databyclosecase = {}
          this.apexchartKeyClosecase++
          resolve()
        })
      })
    },
    getTicketsCloseCaseDetailByAdmin() {
      return new Promise((resolve) => {
        var data = {
          startDate: this.selectedDate.start, // YYYY-MM-DD
          endDate: this.selectedDate.end, // YYYY-MM-DD
          pageid: this.selectedBot.pageid
        }

        if (this.filter.channel) {
          Object.assign(data, { channel: this.filter.channel })
        }
        api.TDGetTicketsCloseCaseDetailByAdmin(data, (err, response) => {
          if (response.data && response.data.length) {
            this.databyclosecasebyadmin = response.data[0]
          } else this.databyclosecasebyadmin = {}
          resolve()
        })
      })
    },
    getTicketsByStatus() {
      return new Promise((resolve) => {
        var data = {
          startDate: this.selectedDate.start, // YYYY-MM-DD
          endDate: this.selectedDate.end, // YYYY-MM-DD
          pageid: this.selectedBot.pageid
        }

        if (this.filter.channel) {
          Object.assign(data, { channel: this.filter.channel })
        }
        api.TDGetTicketsByStatus(data, (err, response) => {
          if (response.data && response.data.length) {
            this.databystatus = response.data[0]
            this.totalticket =
              this.databystatus.answered +
              this.databystatus.cancelled +
              this.databystatus.closed +
              this.databystatus.pending
          } else {
            this.databystatus = {}
          }
          this.apexchartKey++
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/tdtawandang/agentmanagement/Overview.vue